import { EvaluationDuration } from 'domains/calendars/types';
import { useEvaluationCalendar } from 'domains/calendars/v3/useEvaluationCalendar';
import { useEvaluationCalendarSummary } from 'domains/calendars/v3/useEvaluationCalendarSummary';
import { DirectSignupFilters } from 'domains/signupDirect/context';
import { getFilteringAreasByConcernKeys } from 'domains/signupDirect/misc/communicationConcerns';
import { getEvaluationSchedulingWindow } from '../businessLogic/evaluationLeadTimes';

export const useSignupEvaluationCalendar = (
  filters: Pick<DirectSignupFilters, 'clinicalConcernKeys' | 'paymentMethod' | 'stateCode' | 'therapyTarget'>,
  duration: EvaluationDuration,
) => {
  const { paymentMethod, stateCode } = filters;

  const { from: fromDate, to: toDate } = getEvaluationSchedulingWindow(paymentMethod);

  const isInsuranceAndInNetwork =
    paymentMethod.type === 'insurance' && paymentMethod.insuranceData.networkStatus === 'In-network';

  const summaryQuery = useEvaluationCalendarSummary({
    toDate,
    fromDate,
    duration,
    detectedAreas: getFilteringAreasByConcernKeys(filters.clinicalConcernKeys, filters.therapyTarget),
    insuranceName: isInsuranceAndInNetwork ? paymentMethod.insuranceData.insuranceName : undefined,
    state: stateCode,
  });

  const data = useEvaluationCalendar({ query: summaryQuery });

  return data;
};

export type UseEvaluationCalendarResult = ReturnType<typeof useSignupEvaluationCalendar>;
